import { cn } from '@/lib/utils';

const ROW_WIDTHS = ['w-3/4', 'w-1/2', 'w-2/3', 'w-1/2', 'w-3/5', 'w-2/5', 'w-2/3', 'w-1/2'];

/** Placeholder for the note pane while the selected page's detail loads. */
export function NoteContentSkeleton() {
  return (
    <div className="flex h-full flex-col gap-4 p-6" aria-hidden="true">
      <div className="h-7 w-1/3 animate-pulse rounded-md bg-bg-subtle" />
      <div className="-mt-2 h-3 w-48 animate-pulse rounded bg-bg-subtle" />
      <div className="flex flex-col gap-2">
        <div className="h-4 w-full animate-pulse rounded bg-bg-subtle" />
        <div className="h-4 w-5/6 animate-pulse rounded bg-bg-subtle" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-bg-subtle" />
      </div>
    </div>
  );
}

/**
 * Whole-tab placeholder shown while the page list loads, so switching to Notes
 * responds at once instead of leaving the previous tab frozen on screen.
 */
export function NotesSkeleton() {
  return (
    <div className="flex h-full" aria-busy="true" aria-label="Loading pages">
      <aside className="flex w-56 shrink-0 flex-col gap-2 border-r border-border bg-bg px-3 py-2">
        <div className="h-4 w-12 animate-pulse rounded bg-bg-subtle" />
        <div className="h-7 w-full animate-pulse rounded-md bg-bg-subtle" />
        {ROW_WIDTHS.map((w, i) => (
          <div key={i} className={cn('h-4 animate-pulse rounded bg-bg-subtle', w)} />
        ))}
      </aside>
      <main className="flex flex-1 flex-col overflow-hidden">
        <NoteContentSkeleton />
      </main>
    </div>
  );
}
